export default __webpack_public_path__ + "hero-next-320-7d21071632bc5e751412a81b421fc329.bundle.png";